export default "__VITE_ASSET__DcB5siLX__"